import React from 'react';
import { graphql, compose } from 'react-apollo';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getSliders } from '../graphqlDic';
import SlidersComponent from '../components/MainPanel/SlidersComponent';

class SliderList extends React.Component {

    showMainSliderItems = slider_list => {
        let result = [];
        if(typeof slider_list !== 'undefined'){
            if (slider_list.length) {
                for (let i in slider_list) {
                    result.push(
                        <div className="slide-unit" key={i}>
                            <img src={slider_list[i].slider} alt="true" />
                            <div className="container">
                                <div className="info">
                                    <img src={slider_list[i].img} alt="true" className="logo-slide" />
                                    <p className="name">{slider_list[i].name}</p>
                                    <p className="sub-name">{slider_list[i].sub_name}</p>
                                    <Link className="more" to={"/media/watch/" + slider_list[i].id} >Xem</Link>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        }
        return result.length ? result : '';
    }

    showSubSliderItems = slider_list => {
        let result = [];
        if(typeof slider_list !== 'undefined'){
            if (slider_list.length) {
                for (let i in slider_list) {
                    result.push(
                        <div className="slider-nav-unit" key={i}>
                            <img src={slider_list[i].slider} alt="true" className="img-responsive" />
                        </div>
                    );
                }
            }
        }
        return result.length ? result : null;
    }

    render() {
        if (this.props.getSliders.loading) return "Loading...";
        if (this.props.getSliders.error) return `Error! ${this.props.getSliders.error.message}`;
        let sliders = this.props.getSliders.getSliderItems;
        let main_sliders = this.showMainSliderItems(sliders);
        let sub_sliders  = this.showSubSliderItems(sliders);
        return (
            <SlidersComponent main_sliders={ main_sliders } sub_sliders={ sub_sliders } />
        );
    }
}

export default compose(
    graphql(getSliders, {
        name: 'getSliders',
        options: (ownProps) => ({
            variables: {
                type: ownProps.type,
                home_slider_mode: ownProps.home_slider_mode ? ownProps.home_slider_mode : false
            }
        })
    })
)(withRouter(
    connect(
        null
    )(SliderList)
)
);



// WEBPACK FOOTER //
// ./src/containers/SliderList.js